import { Component } from 'react'

import { toast } from 'react-toastify'
import CheckIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'

import SaveOrDiscard from './SaveOrDiscard'
import { editTakeoverSectionTitle } from 'services/LegislationService'
import notificationToast from 'helpers/notificationToast'

export default class TitleEditor extends Component<TitleEditorProps, TitleEditorState> {
  constructor (props: TitleEditorProps) {
    super(props)
    this.state = { value: props.value, saving: false }
  }

  handleOnSave = () => {
    if (this.state.value !== this.props.value) {
      this.setState({ saving: true }, () => {
        const sectionId = this.props.originalNode.id
        const { value } = this.state

        editTakeoverSectionTitle({ id: sectionId, title: value }).subscribe((response: any) => {
          if (response.success) {
            notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Saved!', 'bg-dark-sea-green white')
            window.location.reload() // TODO: there is probably a better way
          } else {
            notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error', 'bg-indian-red white')
          }
          this.setState({ saving: false })
        })
      })
    } else {
      notificationToast(<WarningIcon />, toast.TYPE.WARNING, 'No changes have been made!')
    }
  }

  render () {
    const { hide } = this.props
    const { saving } = this.state

    return (
      <div className='group-header__edit-title'>
        <input
          type='text'
          value={this.state.value}
          onChange={({ target: { value } }) => this.setState({ value })}
        />
        <span className='group-header__admin-button'>
          {saving ? null : (
            <SaveOrDiscard onSave={this.handleOnSave} onDiscard={hide} />
          )}
        </span>
      </div>
    )
  }
}

export interface TitleEditorProps {
  value: string;
  originalNode: {
    id: string;
    title:string;
  }
  hide: () => void;
}

interface TitleEditorState {
  value: string;
  saving: boolean;
}
